import { Appointment } from "../models/admissions.model";
import { EncounterStatusV2 } from "../services/utils";
import { resolveAdmissionsScheduleStatusFromAppointment } from "./admissions-schedule-status.util";

/** Scribe listing: only encounters in these schedule statuses are shown. */
export const SCRIBE_LIST_SCHEDULE_STATUS_ALLOWLIST: readonly string[] = [
  EncounterStatusV2.Confirmed,
  EncounterStatusV2.Open,
  EncounterStatusV2.RetroAuth,
  EncounterStatusV2.ReadyForBilling,
  EncounterStatusV2.Submitted,
] as const;

function normalizeScheduleStatusKey(raw: string): string {
  return (raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/['"]/g, "")
    .replace(/[\s_-]+/g, "");
}

const SCRIBE_SCHEDULE_STATUS_ALLOWLIST_KEYS = new Set(
  SCRIBE_LIST_SCHEDULE_STATUS_ALLOWLIST.map((status) =>
    normalizeScheduleStatusKey(status)
  )
);

export function resolveScribeScheduleStatusFromAppointment(
  appt: Appointment | null | undefined
): string {
  return resolveAdmissionsScheduleStatusFromAppointment(appt);
}

export function isScribeScheduleStatusAllowed(
  appt: Appointment | null | undefined
): boolean {
  const status = resolveScribeScheduleStatusFromAppointment(appt);
  if (!status) {
    return false;
  }
  return SCRIBE_SCHEDULE_STATUS_ALLOWLIST_KEYS.has(
    normalizeScheduleStatusKey(status)
  );
}

export function getScribeListScheduleStatusFilterValues(): string[] {
  return [
    EncounterStatusV2.Confirmed,
    EncounterStatusV2.Scheduled,
    EncounterStatusV2.Open,
    EncounterStatusV2.RetroAuth,
    EncounterStatusV2.ReadyForBilling,
    EncounterStatusV2.SignReq,
    EncounterStatusV2.Submitted,
    EncounterStatusV2.Completed,
  ];
}
